// services/budgetApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ApiReportsResponse,
  GetCoinsStatisticsResponse,
  CoinData,
  CoinDetailsData,
} from '../../../types/reports';
import { baseQueryWithReauth } from '../baseQuery';

export const coinsReportsService = createApi({
  reducerPath: 'coinsReportsService',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getCoinsStatistics: builder.query<GetCoinsStatisticsResponse, void>({
      query: () => ({
        url: `/payments-service/v1/total-revenue/stats`,
      }),
    }),
    getCoins: builder.query<ApiReportsResponse<CoinData>, string>({
      query: (params) => ({
        url: `/payments-service/v1/purchased-coins?${params}`,
      }),
    }),
    getCoinById: builder.query<CoinDetailsData, string>({
      query: (id) => ({
        url: `/payments-service/v1/purchased-coins/details/${id}`,
      }),
    }),
    exportCoins: builder.query<any, { params: string; format: string }>({
      query: ({ params, format }) => ({
        url: `/payments-service/v1/purchased-coins/export-${format}?${params}`,
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const {
  useGetCoinsStatisticsQuery,
  useGetCoinsQuery,
  useGetCoinByIdQuery,
  useLazyExportCoinsQuery,
} = coinsReportsService;
